import "./style.scss";
import {Link, useNavigate} from "react-router-dom";
import {INSTAGRAM, FACEBOOK} from "../../social";
import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {MyContext} from "../App/App";

const Footer = () => {
    const [contact, setContact] = useState("");
    let value = useContext(MyContext);
    const navigate = useNavigate();
    const scrollTop = () => setTimeout(() => window.scrollTo(0, 0), 200);

    useEffect(() => {
        axios.get(`${value.url}contact/`).then((response) => {
            setContact(response.data[0])
        });

    }, []);

    return <>
        <div className="footer-container">
            <div className="footer-body">
                <div className="section-logo">
                    <div className="logo">
                        <img src="./images/logo.webp" alt="leader-auto-ship-logo" loading="lazy"/>
                    </div>
                    <div className="item">
                        <div className="icon">
                            <img src="./images/pin.webp" alt="location-company" loading="lazy"/>
                        </div>
                        <strong className="text">
                            {contact.address}
                        </strong>
                    </div>
                    <div className="item">
                        <div className="icon">
                            <img src="./images/telephone.webp" alt="phone-company" loading="lazy"/>
                        </div>
                        <strong className="text">
                            <a href={`tel:${contact.phone1}`} className="name">(567) 666-4696</a>
                        </strong>
                    </div>
                    <div className="item">
                        <div className="icon">
                            <img src="./images/mail.webp" alt="gmail-company" loading="lazy"/>
                        </div>
                        <strong className="text">
                            <a href={`mailto:${contact.email}`} className="name">{contact.email}</a>
                        </strong>
                    </div>
                    <div className="social-media">
                        <a target="_blank" rel="noopener noreferrer" href={INSTAGRAM}>
                            <img src="./images/Instagram.webp" alt="instagram" loading="lazy"/>
                        </a>

                        {FACEBOOK && <a target="_blank" rel="noopener noreferrer" href={FACEBOOK}>
                            <img src="./images/Facebook.webp" alt="facebook" loading="lazy"/>
                        </a>}
                    </div>
                </div>

                <div className="section-menu">
                    <h3 className="title-footer">
                        Menu
                    </h3>
                    <Link to="/how-it-works" onClick={scrollTop} className="item-footer seo-link">How it works?
                    </Link>
                    <Link to="/for-individuals" onClick={scrollTop} className="item-footer seo-link">For individuals
                    </Link>
                    <Link to="/auto-dealerships" onClick={scrollTop} className="item-footer seo-link">
                        For businesses
                    </Link>
                    <Link to="/about-us" onClick={scrollTop} className="item-footer seo-link">
                        Why us
                    </Link>
                    <Link to="/carrier" onClick={scrollTop} className="item-footer seo-link">
                        Contact
                    </Link>
                </div>

                <div className="section-menu">
                    <div className="title-footer">
                        Useful links
                    </div>

                    <Link to="/about-us" onClick={scrollTop} className="item-footer seo-link">
                        About us
                    </Link>
                    <Link to="/our-team" onClick={scrollTop} className="item-footer seo-link">
                        Our team
                    </Link>
                    <Link to="/reviews" onClick={scrollTop} className="item-footer seo-link">
                        Reviews
                    </Link>
                    <Link to="/auto-dealerships" onClick={scrollTop} className="item-footer seo-link">
                        Auto dealerships
                    </Link>
                    <Link to="/auto-auctions" onClick={scrollTop} className="item-footer seo-link">
                        Auto auctions
                    </Link>
                    <Link to="/rental-car-companies" onClick={scrollTop} className="item-footer seo-link">
                        Rental car companies
                    </Link>
                    <Link to="/rv-transport" onClick={scrollTop} className="item-footer seo-link">
                        RV transport
                    </Link>
                    <Link to="/boat-transport" onClick={scrollTop} className="item-footer seo-link">
                        Boat transport
                    </Link>
                    <Link to="/golf-cart-shipping" onClick={scrollTop} className="item-footer seo-link">
                        Golf cart shipping
                    </Link>

                </div>

                <div className="section-menu">
                    <div className="send-content">
                        <div className="btns">
                            <Link to="/carrier" onClick={scrollTop} className="btn seo-link">
                                Carrier
                            </Link>
                            <Link to="/customer" onClick={scrollTop} className="btn seo-link">
                                Customer
                            </Link>
                        </div>
                        <div className="code">
                            <div className="icons">
                                <img src="./images/partner.png" alt="partner" loading="lazy"/>
                            </div>
                            <div className="text">
                                <div> USDOT: 4232283</div>
                                <div> MC: 1638331</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="sides">
                    <Link to="/" onClick={scrollTop} className="text seo-link">
                        © {new Date().getFullYear()} LEADER AUTO SHIP llc
                    </Link>

                    <div className="line"></div>
                    <div onClick={() => {
                        scrollTop()
                        navigate("/get-quote")
                    }} className="text">
                        ALL RIGHTS RESERVED
                    </div>
                </div>
                <div className="sides">
                    <Link to="/privacy-policy" onClick={scrollTop} className="text seo-link">
                        PRIVACY POLICY
                    </Link>
                    <div className="line"></div>
                    <Link to="/terms-and-conditions" onClick={scrollTop} className="text seo-link">
                        TERMS AND CONDITIONS
                    </Link>
                </div>
            </div>
        </div>
    </>
};

export default Footer;